import ScrollReveal from '@/components/ScrollReveal';
import { useLanguage } from '@/lib/i18n';
import { Instagram, Headphones, ExternalLink } from 'lucide-react';


const socialLinks = [
  { icon: Instagram, label: 'Instagram', href: 'https://www.instagram.com/zateviss' },
  { icon: Headphones, label: 'Spotify', href: 'https://open.spotify.com/intl-tr/artist/5VnhzFb2I1U9qLmLbj6fhZ?si=yZ_vyPpcTkmQ8rx6pkxL5g' },
];

export default function About() {
  const { t } = useLanguage();

  return (
    <main
      id="main-content"
      className="relative pt-32 pb-24 overflow-hidden"
      data-testid="about-page"
    >
      {/* Background Image */}
      <div className="absolute inset-0 -z-10">
        <img
          src="/images/aboutBg.png"
          alt=""
          className="w-full h-full object-cover"
        />
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black/90" />
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24">
          {/* Left: Visual */}
          <ScrollReveal>
            <div className="relative" data-testid="about-visual">
              <div className="aspect-square max-w-md rounded-2xl overflow-hidden relative bg-[#0A0A0A] border border-[#1F1F1F]">
                {/* Gradient bg */}
                <div className="absolute inset-0 bg-gradient-to-br from-[#7F00FF]/[0.06] via-transparent to-[#00E5FF]/[0.06]" />
                {/* Logo centered */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <img
                    src={"images/basicLogo.png"}
                    alt="Zateviss"
                    className="w-full h-full opacity-70"
                  />
                </div>
                {/* Corner glows */}
                <div className="absolute -top-20 -right-20 w-40 h-40 rounded-full bg-[#7F00FF] opacity-[0.06] blur-[80px]" />
                <div className="absolute -bottom-20 -left-20 w-40 h-40 rounded-full bg-[#00E5FF] opacity-[0.06] blur-[80px]" />
              </div>
            </div>
          </ScrollReveal>

          {/* Right: Content */}
          <div>
            <ScrollReveal>
              <p className="font-mono text-[18px] uppercase tracking-[0.3em] text-[#7F00FF]/60 mb-4">
                Producer
              </p>
              <h1
                className="font-syne text-5xl md:text-6xl font-bold tracking-tighter mb-8"
                data-testid="about-page-title"
              >
                {t('about_title')}
              </h1>
            </ScrollReveal>

            {/* Approach */}
            <ScrollReveal delay={0.15}>
              <div className="mb-4 p-6 rounded-xl bg-white/[0.02] border border-white/[0.04]" data-testid="about-approach">
                <h3 className="font-syne font-bold text-lg mb-2">{t('about_zateviss_title')}</h3>
                <p className="text-sm text-white/35 leading-relaxed">{t('about_zateviss_desc')}</p>
              </div>
            </ScrollReveal>
            {/* Approach */}
            <ScrollReveal delay={0.15}>
              <div className="mb-4 p-6 rounded-xl bg-white/[0.02] border border-white/[0.04]" data-testid="about-approach">
                <h3 className="font-syne font-bold text-lg mb-2">{t('about_tag_title')}</h3>
                <p className="text-sm text-white/35 leading-relaxed">{t('about_tag_desc')}</p>
              </div>
            </ScrollReveal>
            {/* Approach */}
            <ScrollReveal delay={0.15}>
              <div className="mb-10 p-6 rounded-xl bg-white/[0.02] border border-white/[0.04]" data-testid="about-approach">
                <h3 className="font-syne font-bold text-lg mb-2">{t('about_vision_title')}</h3>
                <p className="text-sm text-white/35 leading-relaxed">{t('about_vision_desc')}</p>
              </div>
            </ScrollReveal>


            {/* Links */}
            <ScrollReveal delay={0.25}>
              <div data-testid="about-links">
                <h3 className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/25 mb-4">
                  {t('about_links_title')}
                </h3>
                <div className="flex flex-col gap-1">
                  {socialLinks.map(link => (
                    <a
                      key={link.label}
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`about-link-${link.label.toLowerCase()}`}
                      className="flex items-center gap-3 text-sm text-white/35 hover:text-white transition-colors duration-200 group py-2.5 border-b border-white/[0.03]"
                    >
                      <link.icon className="w-4 h-4 text-white/25 group-hover:text-white/60 transition-colors duration-200" />
                      {link.label}
                      <ExternalLink className="w-3 h-3 opacity-0 group-hover:opacity-50 transition-opacity duration-200 ml-auto" />
                    </a>
                  ))}
                </div>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </main>
  );
}
